import { fetchOrderFeedbacks, type OrderFeedback } from "@/domain/order-feedback/order-feedback"
import { getStoredCompany } from "@/lib/company-storage"
import { useCallback, useEffect, useState } from "react"

/** Loads the customer's ratings of the listed orders once per id set; `remember` records a fresh rating locally. */
export function useOrderFeedbacks(orderIds: string[]) {
  const [feedbacks, setFeedbacks] = useState<Record<string, OrderFeedback>>({})
  const key = [...orderIds].sort().join(",")

  useEffect(() => {
    const merchantId = getStoredCompany()?.id
    if (!merchantId || !key) return
    let cancelled = false
    fetchOrderFeedbacks(merchantId, key.split(","))
      .then((byOrder) => {
        if (!cancelled) setFeedbacks((prev) => ({ ...prev, ...byOrder }))
      })
      .catch(() => undefined)
    return () => {
      cancelled = true
    }
  }, [key])

  const remember = useCallback((fb: OrderFeedback) => {
    setFeedbacks((prev) => ({ ...prev, [fb.orderId]: fb }))
  }, [])

  return { feedbacks, remember }
}
